import React, { type HTMLProps } from 'react'

import { Breadcrumb } from '../Breadcrumb'
import type { IBreadcrumbItem } from '../Breadcrumb/Breadcrumb'

interface PageWithBreadcrumbProps extends HTMLProps<HTMLDivElement> {
	title?: string
	links: readonly IBreadcrumbItem[]
}

const PageWithBreadcrumb: React.FC<PageWithBreadcrumbProps> = ({
	children,
	title,
	links,
	...props
}) => (
	<div {...props}>
		<Breadcrumb items={links} currentTitle={title} />
		{children}
	</div>
)

export { PageWithBreadcrumb }
